module.exports = __webpack_public_path__ + "static/media/Edit-Check-Off.3e8715c8.svg";